<template>
  <div class="sized-top-20" v-if="is_loading == true">
    <div class="loader"></div>
  </div>
  <div id="destinations" v-else-if="destinations.length > 0">
    <Destiny class="sized-top-20" v-for="destiny in destinations" :key="destiny.key" v-bind:destiny="destiny" v-on:exclude="removeDestiny"></Destiny>
  </div>
  <div class="sized-top-20" v-else>
    <span class="text-bold">Você não tem clientes cadastrados, vamos começar? Eles são cadastrados automaticamente quando você solicita uma entrega</span>
  </div>
</template>

<script>
import { db } from "../configs/firebase.js";
import Destiny from "../components/Destiny.vue";

export default {
  name: "Destinations",
  data() {
    return {
      is_loading: false,
      destinations: []
    };
  },
  components: {
    Destiny
  },
  computed: {
    user: function() {
      return this.$root.user;
    }
  },
  methods: {
    removeDestiny(key){
      this.destinations = this.destinations.filter(x => x.key != key);
    },
    async getDestinations() {
      try {
        this.is_loading = true;

        let q_destiny = await db
          .ref('destiny_adresses')
          .orderByChild("keys/user_phone")
          .startAt(this.user.uid + '|')
          .endAt(this.user.uid + '|\uf8ff')
          .limitToLast(100)
          .once('value');

        q_destiny.forEach(s_destiny => {
          let destiny = {
            key: s_destiny.key,
            data: s_destiny.val()
          };

          this.destinations.push(destiny);
        });
      } catch (e) {
        //console.log(e);
      } finally {
        this.destinations.sort(function(x, y){
          return y.data.dates.create - x.data.dates.create;
        });

        this.is_loading = false;
      }
    }
  },
  watch: {},
  created() {
    this.getDestinations();
  }
};
</script>

<style>
#destinations {
  text-align: left;
  margin: 20px auto;
  max-width: 912px;
}

@media only screen and (max-width: 912px) {
  #destinations {
    width: 100%;
    padding: 0px;
  }
}
</style>